import {
  BOLD_FONT_VARIANT,
  REGULAR_FONT_VARIANT,
  WebfontFamily,
} from './types';

const standard = true;
const variants: string[] = [REGULAR_FONT_VARIANT, BOLD_FONT_VARIANT];

/**
 * @see https://www.w3schools.com/cssref/css_websafe_fonts.php
 */
export const standardFonts: WebfontFamily<string>[] = [
  { family: 'Arial', standard, variants },
  { family: 'Brush Script MT', standard, variants },
  { family: 'Courier New', standard, variants },
  { family: 'Helvetica', standard, variants },
  { family: 'Georgia', standard, variants },
  { family: 'Tahoma', standard, variants },
  { family: 'Trebuchet MS', standard, variants },
  { family: 'Times New Roman', standard, variants },
  { family: 'Verdana', standard, variants },
];
